<template>
    <div v-if="show" class="suggestion-root shadow" v-on-clickaway="close">
        {{ value }}
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
    mixins: [clickaway],
    name: 'SearchSuggestion',
    props: {
        value: String,
    },
    data: () => ({
        show: false,
    }),
    methods: {
        fetchSuggestions() {
            this.$interfaces.complete
                .get({ query: this.value })
                .then(suggestions => {});
        },
        close() {
            this.show = false;
        },
    },
    watch: {
        value(newVal) {
            // this.show = newVal ? true : false;
        },
    },
};
</script>

<style scoped>
.suggestion-root {
    position: absolute;
    left: 0;
    right: 0;

    background-color: white;
    min-height: 100px;

    z-index: 10000;
}
</style>
